/**
 * 系统用户接口列表
 */
import axios from '@/request/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const miniProgram = {
    //获取系统配置信息
    getCustomizationInfo(params) {
        return axios.post('/order/companyConfiguration/getCustomizationInfo', qs.stringify(params));
    },

}

export default miniProgram;


// WEBPACK FOOTER //
// ./src/request/api/miniProgram/miniProgram.js